import * as fromDatatype from '../datatype-library/index';

export interface bl_b2b_xtn_einvoice_matched_history_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    pt_einvoice_hdr_guid: fromDatatype.GuidDataFieldInterface;
    pt_ipo_xdo_igrn_hdr_guid: fromDatatype.GuidDataFieldInterface;
    supplier_hdr_guid: fromDatatype.GuidDataFieldInterface;
    supplier_code: fromDatatype.VarcharDatatypeInterface;
    supplier_name: fromDatatype.VarcharDatatypeInterface;
    doc_reference_no: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_b2b_xtn_einvoice_matched_history_RowClass implements bl_b2b_xtn_einvoice_matched_history_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    pt_einvoice_hdr_guid: fromDatatype.GuidDataFieldInterface;
    pt_ipo_xdo_igrn_hdr_guid: fromDatatype.GuidDataFieldInterface;
    supplier_hdr_guid: fromDatatype.GuidDataFieldInterface;
    supplier_code: fromDatatype.VarcharDatatypeInterface;
    supplier_name: fromDatatype.VarcharDatatypeInterface;
    doc_reference_no: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
